export default "__VITE_ASSET__ClBqgxUH__"